import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class PublicPinSetAPICall extends APICallV4 {
    _method = 'public/pin/set';
    _type: Method = 'post';
    _retriesCount = 0;
}
